export default __webpack_public_path__ + "static/moa-493130ac860c8030b1ade9f584bd52a8.png";